var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardArrowUpIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: 44444480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m480-555.69-184 184L267.69-400 480-612.31 692.31-400 664-371.69l-184-184Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowUpIc);
export default __webpack_public_path__ + "static/media/keyboard_arrow_up_ic.9f8bce742c6dfd004cf296168e52973d.svg";
export { ForwardRef as ReactComponent };